import React from "react"
import { useSelector } from "react-redux"
// import { selectScopedByClient } from "../../stores/appSlice"
import AdminReportDashboard from "./AdminReportDashboard"

export default function AdminReportPage({ view }) {
    // const scopedByClient = useSelector(selectScopedByClient)

    const renderView = () => {
        switch (view) {
        case "dashboard":
            return renderDashboard()
        }
    }

    const renderDashboard = () => {
        return <AdminReportDashboard />
    }

    return <>{renderView()}</>
}
